module.exports = __webpack_public_path__ + "img/semicirculo-lineal-gris.c844b174.svg";